const apiUrl = process.env.REACT_APP_API_URL;

export const GetJutgeActivitatsIdAlumnes = async (idAct: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/activitats/${idAct}/alumnes`);
        if (!response.ok) return [];
        return await response.json();
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return [];
    }
};
